import { STATUS_FIELDKEY } from '@atlassian/jira-polaris-domain-field/src/field/constants.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { getFieldMappings } from '../../selectors/fields.tsx';
import type { Props, State } from '../../types.tsx';

// Used to remap issue status properties after a change was made in workflow editor
export const refreshStatuses =
	(): Action<State, Props> =>
	async ({ getState, setState }, props) => {
		const state = getState();

		const fieldMappings = getFieldMappings(state, props);
		const statusFieldMapping = fieldMappings[STATUS_FIELDKEY];

		if (!statusFieldMapping) {
			return;
		}

		let newProperties = { ...state.properties };

		state.ids.forEach((localIssueId) => {
			const currentValue = statusFieldMapping.valueAccessor(state, props, localIssueId) || [];
			const foundStatus = props.statusesById?.[currentValue?.id];

			if (foundStatus) {
				newProperties = statusFieldMapping.setImmutable(newProperties, localIssueId, foundStatus);
			}
		});

		setState({ properties: newProperties });
	};
